import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Navigation, Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import {
  ControlButton,
  RecommendedLayersCarousel,
  RecommendedLayersControls,
  RecommendedLayersTitle,
  RecommendedLayersTitleContainer,
  RecommendedLayersWrapper,
} from "./styled";
import { LayerSlide } from "./LayerSlide";
import { layers } from "../../../../resources/layers";
import { useLayerListModule } from "../../../../hooks/appConfig/useAppModule";
import { ResourcesFetchParams } from "../../../Catalog/hooks/useFetchParams";

export const RecommendedLayers: FC = () => {
  const layerListModule = useLayerListModule();
  const { options: { defaultLayersCondition } = {} } = layerListModule;

  const { data, error, loading } = layers.use({
    input: defaultLayersCondition as ResourcesFetchParams,
    waitInput: true,
  });

  const slides = useMemo(() => {
    if (!data?.items) {
      return [];
    }

    return data?.items.map(({ alias, geometryType, preview, name, type }) => ({
      name,
      alias,
      preview,
      geometryType,
      type,
    }));
  }, [data?.items]);

  const { t } = useTranslation("layerList");

  if ((slides.length === 0 && !loading) || error) {
    return null;
  }

  return (
    <RecommendedLayersWrapper>
      <RecommendedLayersTitleContainer>
        <RecommendedLayersTitle>
          {t("recommendedProjectsTitle1")}
          <br />
          {t("recommendedProjectsTitle2")}
        </RecommendedLayersTitle>
        <RecommendedLayersControls>
          <ControlButton className="carousel-prev" kind={"arrow_back"} />
          <ControlButton className="carousel-next" kind={"arrow_forward"} />
        </RecommendedLayersControls>
      </RecommendedLayersTitleContainer>
      <RecommendedLayersCarousel>
        <Swiper
          modules={[Navigation, Virtual]}
          virtual={{
            addSlidesAfter: 2,
            addSlidesBefore: 2,
            enabled: true,
          }}
          height={128}
          spaceBetween={2}
          slidesPerView={2.0125}
          navigation={{
            prevEl: ".carousel-prev",
            nextEl: ".carousel-next",
          }}
        >
          {slides.map(slide => (
            <SwiperSlide key={slide.name}>
              <LayerSlide item={slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      </RecommendedLayersCarousel>
    </RecommendedLayersWrapper>
  );
};
